export enum AsyncStateStatus {
	Idle = 'idle',
	Errored = 'errored',
	Failed = 'failed',
	Received = 'received',
	Requested = 'requested'
}
